module.exports = __webpack_public_path__ + "static/bg7.03ba067f.png";